
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import StepTemp from '@/components/StepTemp/index.vue'
import ConfigBasicInfo from './components/ConfigBasicInfo.vue'
import ConfigLotteryQualification from './components/ConfigLotteryQualification.vue'
import ConfigPrizeSetting from './components/ConfigPrizeSetting.vue'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  createLotteryActivity,
  getLotteryActivityDtl
} from '@/api/marketActivity'
import { arrAddSortNumber } from './../index'

@Component({
  components: {
    StepTemp,
    ConfigBasicInfo,
    ConfigLotteryQualification,
    ConfigPrizeSetting,
    TipsPopup
  }
})
class ActivityConfig extends Vue {
  @Getter companyId!: string

  curStep = 0
  stepList = [
    { title: '基本信息', key: 0 },
    { title: '抽奖资格', key: 1 },
    { title: '奖品设置', key: 2 }
  ]

  // 数据加载标志，用于强制刷新子组件
  dataLoaded = false

  // 表单数据（从接口获取）
  formData = {
    createType: '', // 1创建活动 2创建模板
    templateName: '',
    lotteryConfigId: '',
    // 步骤一：基本信息
    lotteryName: '',
    lotteryTitle: '',
    periodType: 1, // 活动举办周期(1仅一次2每周3每月)， 默认1
    statisticsStartTime: '',
    statisticsEndTime: '',
    lotteryStartTime: '',
    lotteryEndTime: '',
    isSelfEffect: 0, // 是否自动生效(1自动生效0不自动生效)
    // 步骤二：抽奖资格
    // 消费满赠
    isConsumeQualified: 1, // 是否开启消费满赠(1开启0关闭)，默认开启
    sumCost: '',
    lotteryLimit: '',
    // 积分兑换
    isPointQualified: 0, // 是否开启积分兑换(1开启0关闭)，默认关闭
    pointExchange: '',
    // 首单满赠
    isFirstQualified: 0, // 是否开启首单满赠(1开启0关闭)，默认关闭
    firstCost: '',
    firstCostLotteryNum: '',
    // 步骤三：奖品设置
    prizeCreateType: 1,
    prizeList: [],
    isParticipatePrize: 0, // 是否开启参与奖(1开启0关闭)
    participatePrizeType: 1, // 参与奖类型(1自定义2积分)
    participatePrizeTypeName: '',
    participatePrizeName: '',
    participatePrizePoint: '',
    isRequireWriteOff: 0, // 是否开启核销(1开启0关闭)
    budgetType: 1, // 预算金额类型(1固定预算2按营业额比例)，默认固定预算
    budgetMoney: '', // 奖品固定预算金额x元
    budgetRatio: '', // 奖品预算按营业额比例x%
    isLotteryLimit: 0, // 是否存在抽奖限制(1有抽奖限制0无抽奖限制)
    limitList: []
  }

  templateName = ''
  setTemplateLoading = false

  @Watch('curStep')
  onCurStepChange() {
    // 让子组件刷新
    this.dataLoaded = !this.dataLoaded
  }

  created() {
    this.getDetailData()
  }

  // 获取活动详情
  getDetailData() {
    const { lotteryId } = this.$route.query
    if (lotteryId) {
      this.getLotteryActivityDtl(lotteryId)
    }
  }

  // 获取抽奖活动详情
  getLotteryActivityDtl(lotteryId: string | string[]) {
    getLotteryActivityDtl({
      storeId: this.companyId,
      lotteryId
    })
      .then((res) => {
        // 合并数据，保留默认值作为兜底
        let { isConsumeQualified, prizeList = [] } = res.data || {}
        prizeList = prizeList.filter(
          (item) => item.prizeLevel != '参与奖' && item.prizeType
        )
        this.formData = {
          ...this.formData,
          ...(res.data || {}),
          isConsumeQualified: Number(isConsumeQualified),
          prizeList
        }
        // 数据加载完成，触发子组件重新渲染
        this.dataLoaded = true
      })
      .catch(() => {
        // 即使失败也标记加载完成，让子组件使用默认数据渲染
        this.dataLoaded = true
        this.$toast('获取活动详情失败')
      })
  }

  // 下一步
  onNextStep() {
    if (this.curStep < 2) {
      this.curStep++
    }
  }

  // 上一步
  onPrevStep() {
    if (this.curStep > 0) {
      this.curStep--
    }
  }

  // 设为模版
  onSetTemplate() {
    ;(this.$refs.setTemplateTipsPopupRef as any).showPopup()
  }

  onSetTemplateConfirm() {
    if (!this.templateName?.trim()) {
      ;(this.$refs.setTemplateTipsPopupRef as any).showPopup()
      this.$toast('请输入模板名称')
      return false
    }
    this.setTemplateLoading = true
    let { prizeList = [], limitList = [] } = this.formData
    prizeList = arrAddSortNumber(prizeList)
    limitList = arrAddSortNumber(limitList)
    // 设为模版
    createLotteryActivity({
      ...this.formData,
      prizeList,
      limitList,
      createType: 2, // 创建模版
      templateName: this.templateName,
      storeId: this.companyId
    })
      .then(() => {
        this.$toast('设置成功')
      })
      .catch((err) => {
        this.$toast(err.data.msg || '设置失败')
      })
      .finally(() => {
        this.setTemplateLoading = false
      })
  }
}
export default ActivityConfig
